import PropTypes from 'prop-types';

const StatisticsChartEmpty = ({ children, fill = false, className = '', style, as: Tag = 'div' }) => (
	<Tag className={['statistics-chart-empty', fill ? 'statistics-chart-empty--fill' : null, className].filter(Boolean).join(' ')} style={style}>
		{children}
	</Tag>
);

StatisticsChartEmpty.propTypes = {
	children: PropTypes.node.isRequired,
	fill: PropTypes.bool,
	className: PropTypes.string,
	style: PropTypes.object,
	as: PropTypes.elementType,
};

export default StatisticsChartEmpty;
